import { call, put, select, takeLatest } from "redux-saga/effects";
import { fetchCompanyCompareData, getCompetitors } from "../../../services/commonService";
import { FETCH_COMP_COMPARE_REQUEST, FETCH_COMPETITOR_REQUEST, fetchCompCompareFailure, fetchCompCompareSuccess, fetchCompetitorFailure, fetchCompetitorSuccess } from "../actions/companyCompareActions";
import { all } from "axios";

// worker saga
function* fetchcompCompetitorSaga() {
  try {
    // Safely get parameters with fallbacks
    const params = yield select(state => (
      state?.companyCompareReducers?.payload || {}
    ));
    
    // Destructure with validation
    const requiredParams = ['company_name', 'company1_code', 'page_name', 'reports_for'];
    const {
      company_name,
      company1_code,
      company2_code,
      page_name,
      reports_for
    } = params;

    // Validate required parameters
    for (const param of requiredParams) {
      if (!params[param]) throw new Error(`Missing required parameter: ${param}`);
    }

    // Fetch competitors
    const { data } = yield call(getCompetitors, company_name);
    const competitorsData = data?.data || [];

    // Validate competitor data if no company2_code provided
    const company2Code = company2_code || competitorsData[0]?.code;
    if (!company2Code) throw new Error('No competitor code available');

    // Fetch comparison data
    const comparisonPayload = {
      company1_code,
      company2_code: company2Code,
      page_name,
      reports_for
    };
    const compareData = yield call(fetchCompanyCompareData, comparisonPayload);

    // Dispatch success actions

    yield put(fetchCompetitorSuccess(competitorsData))
    yield put(fetchCompCompareSuccess(compareData?.data?.data))

  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    yield put(fetchCompetitorFailure(errorMessage));
  }
}


export function* watchFetchcompCompetitors() {
  yield takeLatest(FETCH_COMPETITOR_REQUEST, fetchcompCompetitorSaga);
}
